import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import LeadGen from '@cont/LeadGen/getStarted/LeadGen';
import getLeadGen from '@cms/api';
import Header from '@layout/HeaderTemplates/Base';
import { fetchOnboardingGoals } from '@actions/topologies';
import Script from 'next/script';
import setupInitialProps from '@utils/setupInitialProps';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const Container = styled.div``;

const GetStarted = ({ apiResponse, utmParams }) => {
  const facebookPixelSnippet = `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '308913771153816');
    fbq('track', 'PageView');`;

  if (!apiResponse) return null;

  return (
    <>
      <Script
        id="segment-fb-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{ __html: facebookPixelSnippet }}
      />
      <NextSeo title="Book a Class" description="Best in class CBSE learning" />
      <Header />
      <LeadGen apiResponse={JSON.parse(apiResponse)} utmParams={utmParams} />
    </>
  );
};

GetStarted.pageInfo = {
  layoutOptions: {
    disableDarkMode: true
  },
  isMWebSupported: true
};

GetStarted.getInitialProps = setupInitialProps(async ({ store, query }) => {
  const { experiment } = query;
  const apiResponse = await getLeadGen(
    `api/lead-gens/cbse-class-6-12/${experiment}`
  );
  const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = query;
  const utmParams = {
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content
  };
  await store.dispatch(fetchOnboardingGoals());

  return {
    apiResponse: JSON.stringify(apiResponse),
    utmParams
  };
}, GetStarted.pageInfo);

GetStarted.Layout = ({ children }) => <Container>{children}</Container>;
GetStarted.Layout.displayName = 'GetStarted';

GetStarted.propTypes = {
  apiResponse: PropTypes.string.isRequired
};

GetStarted.Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default GetStarted;
GetStarted.Wrapper = PageReduxProvider;
